import { delimiter } from "path";
import { Logger } from "./Logger";
import { AppConstants } from "app/core/vo/app-constants";
import { Buffer } from "buffer";

export class UtilityScripts {
	private static arrMonths: Array<string> = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	public static mobileWidth: Number = 414;
	public static iPadWidth: Number = 768;
	public static mobileLandWidth: Number = 812;
	public static iPadLandWidth: Number = 1024;

	public static getRubricName(path: string) {
		const arrPath = path.replace(".swf", "").split("/");
		const rubricName = arrPath.pop().toLowerCase();
		const rubricModuleName = this.getModuleName(rubricName);
		return rubricModuleName;
	}
	public static getModuleName(rubricName) {
		const _iOSDevice =
			this.getSystemDetails()["os"].toLowerCase().indexOf("ios") != -1;
		const _androidDevice =
			this.getSystemDetails()["os"].toLowerCase().indexOf("android") != -1;
		const _windows =
			this.getSystemDetails()["os"].toLowerCase().indexOf("windows") != -1;
		switch (rubricName) {
			case "dualdragdrop":
				if (
					_iOSDevice ||
					_androidDevice ||
					(this.detectTouchscreen() && !_windows)
				) {
					rubricName = "dualdragdropmobile";
				} else {
					rubricName = "dualdragdrop";
				}
				break;
			case "dragdropcolumn":
				if (
					_iOSDevice ||
					_androidDevice ||
					(this.detectTouchscreen() && !_windows)
				) {
					rubricName = "dragdropcolumnmobile";
				} else {
					rubricName = "dragdropcolumn";
				}
				break;
			case "dragdrop_adaptive":
				if (
					_iOSDevice ||
					_androidDevice ||
					(this.detectTouchscreen() && !_windows)
				) {
					rubricName = "dragdrop_mobile_adaptive";
				} else {
					rubricName = "dragdrop_adaptive";
				}
				break;
		}
		return rubricName;
	}
	public static addScroll(document) {
		var strHtml =
			"html{ width: 100%; height: 100%;overflow: hidden; word-break: break-word;}";
		var srtBody =
			"body {width: 100%; height: 96%; overflow: auto; word-break: break-word; -webkit-overflow-scrolling: touch; margin: 0;padding: 0 10px 15px 0; box-sizing: border-box; -webkit-box-sizing: border-box;} span,pre { word-wrap: break-word; overflow-wrap: break-word;} pre,a {white-space: normal; } a {word-break: break-word;overflow-wrap: break-word;}";
		var printBody = 'body {overflow: visible !important}';
		var headEl = document.head || document.getElementsByTagName("head")[0];
		if (headEl) {
			var Style = document.createElement("style");
			Style.setAttribute("id", "style_scroll");
			Style.type = "text/css";

			var printStyle = document.createElement('style');
      printStyle.type ='text/css';
      printStyle.media = 'print';

			if (Style.styleSheet) {
				// This is required for IE8 and below.
				Style.styleSheet.cssText = strHtml;
				Style.styleSheet.cssText = srtBody;
			} else {
				Style.appendChild(document.createTextNode(strHtml));
				Style.appendChild(document.createTextNode(srtBody));
			}
			if(printStyle.styleSheet) {
				printStyle.styleSheet.cssText = printBody;
			} else {
				printStyle.appendChild(document.createTextNode(printBody));
			}
			headEl.appendChild(Style);
			headEl.appendChild(printStyle);
		}
	}

	public static getConfigDetailsFromLocation(strUrl) {
		return (function (a) {
			if (a == "") return {};
			var b = {};
			for (var i = 0; i < a.length; ++i) {
				var p = a[i].split("=", 2);
				if (p.length != 2) continue;
				b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
			}
			return b;
		})(strUrl); //window.location.search.substr(1).split('&')
	}
	public static removeFontSizeTag(str) {
		var text = str.replace("size=", "");
		return text;
	}

	public static dateToYMD(date, language) {
		var d = date.getDate();
		var m = date.getMonth() + 1;
		var y = date.getFullYear();
		var n = this.arrMonths[date.getMonth()];
		if (language != undefined && language == "english") {
			return n + " " + (d <= 9 ? "0" + d : d) + "," + " " + y;
		}
		return date.getMonth() + 1 + " / " + (d <= 9 ? "0" + d : d) + " / " + y;
	}

	public static searchReplace(
		str: string,
		search: string,
		replace: string
	): string {
		while (str.search(search) !== -1) {
			str = str.replace(search, replace);
		}
		return str;
	}
	public static search(str: string, search: string): boolean {
		while (str.search(search) !== -1) {
			return true;
		}
		return false;
	}
	public static deserializeArray(str: string, ...delim: any[]) {
		let retArray: any[];
		let delimeter: string = delim[0];
		let tempArray: string[] = [];
		tempArray = str.split(delimiter);
		retArray = tempArray;

		for (let i: number; i < delim.length; i++) {
			delimeter = delim[i];
			for (let j: number = 0; j < retArray.length; j++) {
				const str: string = retArray[j];
				tempArray = str.split(delimeter);
				retArray.push(tempArray);
			}
		}
		return retArray;
	}

	public static serializeArray(arr: string[], delim: string): string {
		let counter: number = 0;
		let str: string = "";
		for (let item in arr) {
			if (counter < arr.length) {
				str += arr[counter] + delim;
			} else {
				str += arr[counter];
			}
			counter++;
		}
		return str;
	}

	public static dataEscapeUnescape(
		dataStr: string,
		type: string,
		escapeCount: number = 0
	): string {
		for (let i: number = 0; i < escapeCount; i++) {
			if (type === "escape") {
				dataStr = escape(dataStr);
			} else if (type === "unescape") {
				dataStr = unescape(dataStr);
			}
		}
		return dataStr;
	}
	public static getLanguageCode(lang: string) {
		let languageCode = new Map<string, string>();
			languageCode.set("english", "en");
			languageCode.set("chinese", "zh");
			languageCode.set("dutch", "nl");
			languageCode.set("french_ca", "fr");
			languageCode.set("french", "fr");
			languageCode.set("german", "de");
			languageCode.set("italian", "it");
			languageCode.set("japanese", "ja");
			languageCode.set("korean", "ko");
			languageCode.set("portuguese", "pt");
			languageCode.set("russian", "ru");
			languageCode.set("las", "es-419");
			languageCode.set("spanish_eu", "es");
			languageCode.set("uk_english", "en-GB");
			languageCode.set("portuguese_port", "pt-PT");
			languageCode.set("romanian", "ro");
			languageCode.set("malay", "ms");
			languageCode.set("thai", "th");
			languageCode.set("hebrew", "he");
			languageCode.set("bulgarian", "bg");
			languageCode.set("croatian", "hr");
			languageCode.set("czech", "cs");
			languageCode.set("hungarian", "hu");
			languageCode.set("serbian_lat", "sr");
			languageCode.set("slovak", "sk");
			languageCode.set("slovenian", "sl");
			languageCode.set("swedish", "sv");
			languageCode.set("indonesian", "id");
			languageCode.set("polish", "pl");
			languageCode.set("finnish", "fi");
			languageCode.set("turkish", "tr");
			languageCode.set("arabic", "ar");
			languageCode.set("somali", "so");
			languageCode.set("chinese_tr", "zh-Hant");
			languageCode.set("hindi", "hi");
			languageCode.set("tagalog", "tl");
			languageCode.set("bosnian", "bs");
			languageCode.set("norwegian", "no");
			languageCode.set("ukrainian", "uk");
			languageCode.set("vietnamese", "vi");

			var langCode = languageCode.get(lang);
		return langCode === null || langCode === undefined ? "en" : langCode;
	}
	public static convertFromMS(milliseconds: Number): string {
		if (milliseconds) {
			var sTime: any = milliseconds;
			var sessionHours_int: any = Math.floor(sTime / 3600000); // getting  Hour
			sTime -= sessionHours_int * 3600000;
			var sessionMinutes_int: any = Math.floor(sTime / 60000); // getting  minutes
			sTime -= sessionMinutes_int * 60000;
			var sessionSeconds_int: any = Math.floor(sTime / 1000); // // getting  secs

			sTime -= sessionSeconds_int * 1000;

			var timeCode: string =
				this.addZero(sessionHours_int, 4) +
				":" +
				this.addZero(sessionMinutes_int, 2) +
				":" +
				this.addZero(sessionSeconds_int, 2);
			return timeCode;
		}
		return "0000:00:00";
	}
	public static convertToMS(totaltime: string): number {
		var time_str: string = totaltime;
		var time_array: Array<any> = time_str.split(":");
		if (!time_array) {
			return 0;
		}
		if (time_array.length == 3) {
			var hoursetoMs: number = parseInt(time_array[0]) * 3600000; //  converting hour to milliseconds
			var mintoMs: number = parseInt(time_array[1]) * 60000; //  converting minute to milliseconds
			var secstoMs: number = parseInt(time_array[2]) * 1000; //  converting secs to milliseconds
			var totaltimetoMs: number = hoursetoMs + mintoMs + secstoMs; //   getting total milliseconds
			return totaltimetoMs;
		} else {
			return 0;
		}
	}
	public static addZero(inNum: Number, totalDigits: any): String {
		var zeroString: string = "";
		var string: string = inNum.toString();
		for (var i: number = 0; i < totalDigits - string.length; i++) {
			zeroString += "0";
		}
		return zeroString + string;
	}
	public static getClockFormat(time_int: number): string {
		let hours_int: number = Math.floor(time_int / 3600000);
		time_int -= hours_int * 3600000;
		var minutes_int = Math.floor(time_int / 60000);
		time_int -= minutes_int * 60000;
		var seconds_int = Math.floor(time_int / 1000);
		return (
			this.addZero(hours_int, 1) +
			":" +
			this.addZero(minutes_int, 2) +
			":" +
			this.addZero(seconds_int, 2)
		);
	}

	public static isXML(str) {
		let oParser = new DOMParser();
		let oDOM = oParser.parseFromString(str, "text/xml");
		return oDOM.documentElement.nodeName === "parsererror" ? false : true;
	}

	public static pruneXMLNodes(xmlData, attribute, value, match?) {
		let count: number = 0;
		let countLen: number = xmlData.childNodes.length;
		let node;
		for (count = 0; count < countLen; ++count) {
			node = xmlData.childNodes[count];
			if (
				node.nodeName !== "#text" &&
				node.nodeName !== "#comment" &&
				node.nodeName !== "#cdata-section"
			) {
				if (node.hasAttributes() && node.getAttributeNode(attribute) != null) {
					if (
						(match &&
							node.getAttributeNode(attribute).nodeValue.toLowerCase() !==
								value.toLowerCase()) ||
						(match === undefined &&
							((node
								.getAttributeNode(attribute)
								.nodeValue.toLowerCase()
								.indexOf(",") === -1 &&
								node.getAttributeNode(attribute).nodeValue.toLowerCase() !==
									value.toLowerCase()) ||
								(node
									.getAttributeNode(attribute)
									.nodeValue.toLowerCase()
									.indexOf(",") !== -1 &&
									node
										.getAttributeNode(attribute)
										.nodeValue.toLowerCase()
										.indexOf(value.toLowerCase()) === -1)))
					) {
						xmlData.removeChild(node);
						--countLen;
						--count;
					}
				}
				if (node.hasChildNodes()) {
					this.pruneXMLNodes(node, attribute, value);
				}
			}
		}
	}

	public static overridePresentationMode(xmlData, strPresentationMode): string {
		let node = xmlData.getElementsByTagName("presentationModeOverride");
		let countLen = node.length;

		if (countLen > 0 && node[0].getAttributeNode("changeFrom")) {
			for (let count = 0; count < countLen; count++) {
				if (
					node[count].getAttributeNode("changeFrom").value ===
					strPresentationMode
				) {
					strPresentationMode = node[count].getAttributeNode("changeTo").value;
				}
			}
		}
		return strPresentationMode;
	}
	public static detectTouchscreen() {
		var result = false;
		if ("maxTouchPoints" in navigator) {
			// if Pointer Events are supported, just check maxTouchPoints
			if (navigator.maxTouchPoints > 0) {
				result = true;
			}
		} else {
			// no Pointer Events...
			if (
				window.matchMedia &&
				window.matchMedia("(any-pointer:coarse)").matches
			) {
				// check for any-pointer:coarse which mostly means touchscreen
				result = true;
			} else if ("ontouchstart" in window) {
				// last resort - check for exposed touch events API / event handler
				result = true;
			}
		}
		return result;
	}
	public static isMobileDevice(): boolean {
		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			) ||
			navigator.platform.indexOf("MacIntel") != -1
		) {
			return true;
		}
		return false;
	}

	public static isIE11() {
		return /MSIE \d|Trident.*rv:/i.test(navigator.userAgent);
	}

	public static removeHTMLTags(str: string) {
		str = str.replace(/&nbsp;/gi, "");
		return str.replace(/<[^>]*>/g, "");
	}
	public static addEnAndEmDash(str: string) {
		str = str.split("&#8211;").join("–");
		return str.split("&#8212;").join("—");
	}
	public static async addScriptTag(script: string) {
		return new Promise((resolve) => {
			var scripttag = document.createElement("script");
			scripttag.type = "text/javascript";
			scripttag.src = script;
			const head = document.getElementsByTagName("head")[0];
			head.appendChild(scripttag);
			scripttag.onload = function () {
				resolve("scriptLoaded");
			};
		});
	}
	public static setTextDirection(element: HTMLElement, direction: string) {
		element.style.direction = direction;
	}
	public static addStyleTag(style: string) {
		var linkTag = document.createElement("link");
		linkTag.type = "text/css";
		linkTag.rel = "stylesheet";
		linkTag.href = style;
		const head = document.getElementsByTagName("head")[0];
		head.appendChild(linkTag);
	}
	public static removeStyleTag(styleSrc: string) {
		const linkTags = document.getElementsByTagName("link");
		for (let i = 0; i < linkTags.length; i++) {
			if (linkTags[i].href.indexOf(styleSrc) !== -1) {
				linkTags[i].disabled = true;
			}
		}
	}

	public static convertPTHMStoHHMMSS(time) {
		time = typeof time == "string" ? time : "PT0H0M0S";

		const pattern = /P([^T]+)?(T((\d*)H)?((\d*)M)?((\d*)S)?)?/i;

		let matches = time.match(pattern);

		matches = matches ? matches : [];

		return this.resolveTimeFromParts({
			hours: matches[4],
			minutes: matches[6],
			seconds: matches[8],
			includeMS: false,
		});
	}

	public static resolveTime(time) {
		const defaultTimeAsZeros = "0000:00:00.00";

		let resolvedTime = typeof time == "string" ? time : defaultTimeAsZeros;

		let matches = resolvedTime.match(
			/(\d{1,4}):(\d{1,2}):(\d{1,2})(\.(\d{1,2}))?/
		);

		matches = matches ? matches : [];

		resolvedTime = !!matches
			? this.resolveTimeFromParts({
					hours: matches[1],
					minutes: matches[2],
					seconds: matches[3],
					milliseconds: matches[5],
					includeMS: true,
			  })
			: defaultTimeAsZeros;

		return resolvedTime;
	}

	public static resolveTimeFromParts(timeParts) {
		let result =
			this.resolveTimePart(timeParts.hours, "h") +
			":" +
			this.resolveTimePart(timeParts.minutes, "m") +
			":" +
			this.resolveTimePart(timeParts.seconds, "s");

		return timeParts.includeMS === true
			? result + "." + this.resolveTimePart(timeParts.milliseconds, "ms")
			: result;
	}

	public static resolveTimePart(timePart, partType) {
		let result = null;

		if (
			"string" != typeof partType ||
			!partType.toLowerCase().match(/^(h|m|s|ms)$/)
		)
			throw (
				"Invalid Value for argument (partType): " +
				partType +
				"\nMust use any of the following valid values: (h, m, s, ms)"
			);

		timePart =
			"string" == typeof timePart && !!timePart.match(/\d+/) ? timePart : "0";

		switch (partType) {
			case "h":
				result = timePart.padStart(4, "0");
				break;

			case "ms":
				result = timePart.padEnd(2, "0");
				break;

			case "m":
			case "s":
			default:
				result = timePart.padStart(2, "0");
				break;
		}

		return result;
	}

	public static convertMillisecondsToISO8601Duration(inputMilliseconds) {
		let hours: number,
			minutes,
			seconds,
			i_inputMilliseconds = parseInt(inputMilliseconds, 10),
			inputIsNegative = "",
			rtnStr = "";

		if (i_inputMilliseconds < 0) {
			inputIsNegative = "-";
			i_inputMilliseconds = i_inputMilliseconds * -1;
		}

		hours = parseInt(String(i_inputMilliseconds / 3600000), 10);
		minutes = parseInt(String((i_inputMilliseconds % 3600000) / 60000), 10);
		seconds = ((i_inputMilliseconds % 3600000) % 60000) / 1000;

		rtnStr = inputIsNegative + "PT";
		if (hours > 0) {
			rtnStr += hours + "H";
		}

		if (minutes > 0) {
			rtnStr += minutes + "M";
		}

		rtnStr += seconds + "S";

		return rtnStr;
	}

	private static getRandomHexValues(numberOfHexValues: number) {
		const numberOfBytes = numberOfHexValues / 2;
		const randomBytesArray = new Uint8Array(numberOfBytes);
		crypto.getRandomValues(randomBytesArray);
		const randomBytesBuffer = Buffer.from(randomBytesArray.buffer);
		return randomBytesBuffer.toString("hex");
	}

	public static getuuidv4() {
		/*
      RFC 4122

      The formal definition of the UUID string representation is
      provided by the following ABNF [7]:

      UUID                   = time-low "-" time-mid "-"
                               time-high-and-version "-"
                               clock-seq-and-reserved
                               clock-seq-low "-" node
      time-low               = 4hexOctet
      time-mid               = 2hexOctet
      time-high-and-version  = 2hexOctet
      clock-seq-and-reserved = hexOctet
      clock-seq-low          = hexOctet
      node                   = 6hexOctet
      hexOctet               = hexDigit hexDigit
      hexDigit =
            "0" / "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" /
            "a" / "b" / "c" / "d" / "e" / "f" /
            "A" / "B" / "C" / "D" / "E" / "F"

      Algorithms for Creating a UUID from Truly Random or
      Pseudo-Random Numbers

      The version 4 UUID is meant for generating UUIDs from truly-random or
      pseudo-random numbers.
      
      The algorithm is as follows:
      
      o  Set the two most significant bits (bits 6 and 7) of the
         clock_seq_hi_and_reserved to zero and one, respectively.
      
      o  Set the four most significant bits (bits 12 through 15) of the
         time_hi_and_version field to the 4-bit version number from Section 4.1.3.
         
      o  Set all the other bits to randomly (or pseudo-randomly) chosen
         values.
    */

		console.log(process.version);
		const timeLow = UtilityScripts.getRandomHexValues(8);
		const timeMid = UtilityScripts.getRandomHexValues(4);
		const timeHighAndVersion = (() => {
			let timeHighAndVersion = crypto.getRandomValues(new Uint8Array(2));
			timeHighAndVersion[0] |= 1 << 6;
			timeHighAndVersion[0] &= ~((1 << 7) | (1 << 5) | (1 << 4));
			return Buffer.from(timeHighAndVersion.buffer).toString("hex");
		})();
		const clockSeqAndReserved = (() => {
			let clockSeqAndReserved = crypto.getRandomValues(new Uint8Array(1));
			clockSeqAndReserved[0] |= 1 << 7;
			clockSeqAndReserved[0] &= ~(1 << 6);
			return Buffer.from(clockSeqAndReserved.buffer).toString("hex");
		})();
		const clockSeqLow = UtilityScripts.getRandomHexValues(2);
		const node = UtilityScripts.getRandomHexValues(12);

		return `${timeLow}-${timeMid}-${timeHighAndVersion}-${clockSeqAndReserved}${clockSeqLow}-${node}`;
	}

	public static getSystemDetails(userAgent = navigator.userAgent) {
		let unknown = "-";
		let defaultBrowser = "Unknown Browser";
		// screen
		let screenSize = "";
		if (screen && screen.width) {
			let width = screen.width ? screen.width : "";
			let height = screen.height ? screen.height : "";
			screenSize += "" + width + " x " + height;
		}
		// browser
		let nVer = navigator.appVersion;
		let browser = navigator.appName;
		let nAgt = userAgent;
		let version = "" + parseFloat(navigator.appVersion);
		let majorVersion: any = parseInt(navigator.appVersion, 10);
		let nameOffset, verOffset, ix;
		// Opera
		if ((verOffset = nAgt.indexOf("Opera")) != -1) {
			browser = "Opera";
			version = nAgt.substring(verOffset + 6);
			if ((verOffset = nAgt.indexOf("Version")) != -1) {
				version = nAgt.substring(verOffset + 8);
			}
		}
		// Opera Next
		if ((verOffset = nAgt.indexOf("OPR")) != -1) {
			browser = "Opera";
			version = nAgt.substring(verOffset + 4);
		}
		// Edge
		else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
			browser = "Microsoft Edge";
			version = nAgt.substring(verOffset + 4);
		}
		// MSIE
		else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
			browser = "Microsoft Internet Explorer";
			version = nAgt.substring(verOffset + 5);
		}
		// Chrome
		else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
			browser = "Chrome";
			version = nAgt.substring(verOffset + 7);
		}
		// Safari
		else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
			browser = "Safari";
			version = nAgt.substring(verOffset + 7);
			if ((verOffset = nAgt.indexOf("Version")) != -1) {
				version = nAgt.substring(verOffset + 8);
			}
		}
		// Firefox
		else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
			browser = "Firefox";
			version = nAgt.substring(verOffset + 8);
		}
		// MSIE 11+
		else if (nAgt.indexOf("Trident/") != -1) {
			browser = "Microsoft Internet Explorer";
			version = nAgt.substring(nAgt.indexOf("rv:") + 3);
		}
		// Other browsers
		else if (
			(nameOffset = nAgt.lastIndexOf(" ") + 1) <
			(verOffset = nAgt.lastIndexOf("/"))
		) {
			browser = defaultBrowser; //nAgt.substring(nameOffset, verOffset);
			version = nAgt.substring(verOffset + 1);
			/*if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }*/
		}
		//console.log("Browser: ",browser)
		// trim the version string
		if ((ix = version.indexOf(";")) != -1) version = version.substring(0, ix);
		if ((ix = version.indexOf(" ")) != -1) version = version.substring(0, ix);
		if ((ix = version.indexOf(")")) != -1) version = version.substring(0, ix);
		majorVersion = parseInt("" + version, 10);
		if (isNaN(majorVersion)) {
			version = "" + parseFloat(navigator.appVersion);
			majorVersion = parseInt(navigator.appVersion, 10);
		}

		if (browser == defaultBrowser) {
			majorVersion = "";
		}
		// mobile version
		let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);
		// cookie
		let cookieEnabled = navigator.cookieEnabled ? true : false;
		if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
			document.cookie = "testcookie";
			cookieEnabled =
				document.cookie.indexOf("testcookie") != -1 ? true : false;
		}
		// system
		let os = unknown;
		let clientStrings = [
			/*{s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},*/
			{
				s: "Windows",
				r: /((Windows)( NT)?) (([78]|\d\d)([.]\d+)?|[^2-69].\d|6.[1-3])/,
			},
			{ s: "Windows Vista", r: /Windows NT 6.0/ },
			{ s: "Windows Server 2003", r: /Windows NT 5.2/ },
			{ s: "Windows XP", r: /(Windows (XP|NT 5.1))/ },
			{ s: "Windows 2000", r: /(Windows (2000|NT 5.0))/ },
			{ s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
			{ s: "Windows 98", r: /(Win(dows )?98)/ },
			{ s: "Windows 95", r: /(Win(dows[\s_])?95)/ },
			{ s: "Windows NT 4.0", r: /(Win(dows\s?)?NT(\s?4.0)?)/ },
			{ s: "Windows CE", r: /Windows CE/ },
			{ s: "Windows Phone", r: /Windows Phone/ },
			{ s: "Windows 3.11", r: /Win16/ },
			{ s: "Open BSD", r: /OpenBSD/ },
			{ s: "Sun OS", r: /SunOS/ },
			{ s: "Chrome OS", r: /CrOS/ },
			/*{s:'Linux', r:/(Linux|X11(?!.*CrOS))/},*/
			{ s: "Linux", r: /(Ubuntu|X11(?!.*CrOS))/ },
			{ s: "iOS", r: /(iPhone|iPad|iPod)/ },
			{ s: "Mac OS X", r: /Mac OS X/ },
			{ s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
			{ s: "QNX", r: /QNX/ },
			{ s: "UNIX", r: /UNIX/ },
			{ s: "BeOS", r: /BeOS/ },
			{ s: "OS/2", r: /OS\/2/ },
			{
				s: "Search Bot",
				r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
			},
			{ s: "CrKey", r: /CrKey/ },
			{ s: "Android", r: /Android/ },
		];
		for (let id in clientStrings) {
			let cs = clientStrings[id];
			if (cs.r.test(nAgt)) {
				os = cs.s;
				break;
			}
		}
		var osVersion = "";
		var matches =
			/((Windows Phone|Chrome|NT|Mac OS|Mac|Linux|CrOS|armv7l|Android)[\s]*) ([(\(.|x|X|_|\d)\(\(.|x|X|_|\d)\(\(.|x|X|_|\d))]+)/.exec(
				nAgt
			);
		osVersion = matches && matches.length > 2 ? matches[3] : "";
		osVersion = osVersion.replace(/[)]/g, "");

		let viewPort: string = this.getViewport();

		let obj = {};
		obj["screen"] = screenSize;
		obj["browser"] = browser;
		obj["browserVersion"] = version;
		obj["browserMajorVersion"] = majorVersion;
		obj["mobile"] = mobile;
		obj["os"] = os;
		obj["osVersion"] = osVersion;
		obj["cookies"] = cookieEnabled;
		obj["viewport"] = viewPort;
		return obj;
	}

	public static browserAndSystemInfo(newlnChar = "") {
		let val = "";
		let systemInfo = this.getSystemDetails();
		val += "&os>" + systemInfo["os"] + "" + systemInfo["osVersion"] + newlnChar;
		val +=
			"&browser>" +
			systemInfo["browser"] +
			"" +
			systemInfo["browserMajorVersion"] +
			newlnChar;
		return val;
	}

	public static stripTrailingSlash(url) {
		return url.replace(/\/+$/g, "");
	}

	public static getViewport() {
		const width = Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		);
		if (width <= 576) return "xs";
		if (width <= 768) return "sm";
		if (width <= 992) return "md";
		if (width <= 1200) return "lg";
		return "xl";
	}

	public static getSpeedVariables(): any[] {
		const speedVariables: any[] = [
			{ value: 0.25, label: "0.25x" },
			{ value: 0.5, label: "0.5x" },
			{ value: 0.75, label: "0.75x" },
			{ value: 1, label: "Normal speed", selected: true },
			{ value: 1.25, label: "1.25x" },
			{ value: 1.5, label: "1.5x" },
			{ value: 1.75, label: "1.75x" },
			{ value: 2, label: "2x" },
		];
		return speedVariables;
	}

	public static getDocumentURL(docUrl: string) {
		let url;
		const systemDetails = this.getSystemDetails();
		const browser = systemDetails["browser"];
		const browserMajorVersion = systemDetails["browserMajorVersion"];
		const os = systemDetails["os"]; //"iOS"
		const isOldIpad =
			browser.toLowerCase() == "safari" &&
			browserMajorVersion < 12 &&
			os.toLowerCase() == "ios"
				? true
				: false;
		if (!isOldIpad) {
			url =
				docUrl.toLowerCase().indexOf(".pdf") != -1
					? "./assets/pdf/viewer.html?../../" + docUrl
					: docUrl.toLowerCase().replace(".swf", ".html");
		} else {
			url = docUrl.replace(".swf", ".html");
		}
		console.log("doc URL ", url);
		return url;
	}

	public static checkIsImage(locPath: string) {
		let pattern = /\.(jpg|jpeg|png)$/i;
		let result = pattern.test(locPath);
		return result;
	}

	/* This function will add style attribute to the given html tag and return updated parent tag (string)
  eg: "<body>Hi all <a>Click here</a></body>" we need to add style for 'a' tag => style="display: inline-block; color: black"
  Parameters:- parentTag - string that contains the tag, where we need to add styles -> "<body> to </body>"
               tagName - Name of the tag, where we need to add style attribute -> "a"
               styles - "display: inline-block; color: black"
  */
	public static addStyleAttribute(
		parentTag: string,
		tagName: string,
		styles: string
	): string {
		let tagStart: number = parentTag.indexOf("<" + tagName + " ");
		if (tagStart > -1) {
			let tagEnd: number = tagStart + parentTag.slice(tagStart).indexOf(">");
			let updatedPart: string =
				parentTag.slice(tagStart, tagEnd) +
				" style=" +
				'"' +
				styles +
				'"' +
				parentTag.slice(tagEnd);
			return parentTag.slice(0, tagStart) + updatedPart;
		}
		return parentTag;
	}
	public static isFirefoxOrMobile(): boolean {
		return (
			UtilityScripts.getSystemDetails()["mobile"] ||
			UtilityScripts.getSystemDetails()["browser"] == "Firefox"
		);
	}
	public static isCustomFontNeeded(currentLanguage): boolean{
		return (currentLanguage ===
			AppConstants.CZECH || currentLanguage === AppConstants.POLISH || currentLanguage === AppConstants.VIETNAMESE || currentLanguage === AppConstants.ROMANIAN ||currentLanguage === AppConstants.SLOVAK || currentLanguage === AppConstants.HUNGARIAN || currentLanguage === AppConstants.SLOVENIAN || currentLanguage === AppConstants.BOSNIAN || currentLanguage === AppConstants.TURKISH || currentLanguage === AppConstants.CROATIAN)
			? true
			: false;
	}
/**
 * Function to identify IOS platform
 * @returns True/False
 */
  public static isIOSPlatform():boolean{
    return (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel'));
  }

  public static isFF() {
		const browser: string = UtilityScripts.getSystemDetails()
			["browser"].toLowerCase()
			.replace(/\s/g, "");
		if (browser === "firefox") {
			return true;
		}
		return false;
	}
}
const getTimePart = (timePart) => (timePart ? timePart : "");

declare function unescape(s: string): string;
declare function escape(s: string): string;
